import { pick } from 'lodash';

import { Column, Row } from '../entities/system-logs';

export function flattenRows(
  rows: Row[],
  columns: Column[],
): Record<string, unknown>[] {
  const colIds = columns.map((c) => c.id);
  return rows.map((r) => ({
    id: r.id,
    ...pick(r.cells, colIds),
  }));
}
